"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function TranslationDetector({ currentLang }) {
  const pathname = usePathname();

  useEffect(() => {
    let isNavigating = false;

    const handleLanguageChange = () => {
      if (isNavigating) return;

      const targetLang = document.documentElement.lang.toLowerCase();
      const isTranslated =
        document.documentElement.classList.contains("translated-ltr") ||
        document.documentElement.classList.contains("translated-rtl");

      if (
        isTranslated &&
        ["en", "es"].includes(targetLang) &&
        targetLang !== currentLang
      ) {
        isNavigating = true;

        document.cookie = `PREFERRED_LOCALE=${targetLang};path=/;max-age=${
          365 * 24 * 60 * 60
        }`;
        window.location.reload();
      }
    };

    // Set up mutation observer for translation changes
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class" &&
          mutation.target === document.documentElement
        ) {
          handleLanguageChange();
        }
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => {
      observer.disconnect();
    };
  }, [currentLang, pathname]);

  return null;
}
